import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { Search, LogIn, LogOut, User, Bookmark, Heart, Clock, TrendingUp, Film } from 'lucide-react'
import { supabase } from '../lib/supabase'

export default function Header({ session }) {
  const [search, setSearch] = useState('')
  const [mobileMenu, setMobileMenu] = useState(false)
  const navigate = useNavigate()

  const handleSearch = (e) => {
    e.preventDefault()
    if (search.trim()) {
      navigate(`/search?q=${encodeURIComponent(search.trim())}`)
      setSearch('')
    }
  }

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/')
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-dark-900/95 backdrop-blur-md border-b border-dark-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <Film className="w-7 h-7 text-primary-500 group-hover:scale-110 transition-transform" />
            <span className="text-2xl font-black tracking-tight">
              <span className="text-primary-500">IC</span>
              <span className="text-white">LIX</span>
            </span>
          </Link>

          {/* Nav Desktop */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-medium text-gray-300 hover:text-white transition-colors">Beranda</Link>
            <Link to="/trending" className="text-sm font-medium text-gray-300 hover:text-white transition-colors flex items-center gap-1">
              <TrendingUp className="w-4 h-4" /> Trending
            </Link>
            <Link to="/genre/action" className="text-sm font-medium text-gray-300 hover:text-white transition-colors">Genre</Link>
          </nav>

          {/* Search + Auth */}
          <div className="flex items-center gap-3">
            <form onSubmit={handleSearch} className="hidden sm:flex items-center">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Cari film..."
                  className="pl-9 pr-4 py-2 rounded-lg bg-dark-800 border border-dark-700 text-sm w-48 lg:w-64 focus:outline-none focus:border-primary-500 transition-colors"
                />
              </div>
            </form>

            {session ? (
              <div className="relative group">
                <button className="flex items-center gap-2 p-2 rounded-lg hover:bg-dark-800 transition-colors" onClick={() => setMobileMenu(!mobileMenu)}>
                  <User className="w-5 h-5 text-gray-300" />
                  <span className="text-sm text-gray-300 hidden sm:inline">{session.user.email?.split('@')[0]}</span>
                </button>
                <div className={`absolute right-0 top-full mt-2 w-56 bg-dark-800 border border-dark-700 rounded-xl shadow-2xl overflow-hidden ${mobileMenu ? 'block' : 'hidden group-hover:block'} z-50`}>
                  <div className="p-3 border-b border-dark-700">
                    <p className="text-sm font-medium text-white truncate">{session.user.email}</p>
                  </div>
                  <div className="p-2">
                    {[
                      { to: '/profile', icon: User, label: 'Profil' },
                      { to: '/watchlist', icon: Bookmark, label: 'Watchlist' },
                      { to: '/favorites', icon: Heart, label: 'Favorit' },
                      { to: '/history', icon: Clock, label: 'Riwayat' },
                    ].map(({ to, icon: Icon, label }) => (
                      <Link key={to} to={to} className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-300 hover:text-white hover:bg-dark-700 transition-colors" onClick={() => setMobileMenu(false)}>
                        <Icon className="w-4 h-4" /> {label}
                      </Link>
                    ))}
                  </div>
                  <div className="p-2 border-t border-dark-700">
                    <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 w-full transition-colors">
                      <LogOut className="w-4 h-4" /> Keluar
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Link to="/auth" className="flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors">
                <LogIn className="w-4 h-4" /> Masuk
              </Link>
            )}

            {/* Mobile search */}
            <button className="sm:hidden p-2" onClick={() => setSearch('')}>
              <Search className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}
